import classNames from 'classnames';
import { FC, ReactNode } from 'react';

type StatusPanelProps = Readonly<{
  children: ReactNode;
  className: string;
  e2e?: string;
}>;

export const StatusPanel: FC<StatusPanelProps> = ({ className, children, e2e }) => {
  return (
    <div
      className={classNames('alert mb-0 px-3 py-2 mt-1 d-flex justify-content-start align-items-center', className)}
      data-e2e={e2e}
    >
      {children}
    </div>
  );
};

StatusPanel.displayName = 'StatusPanel';
